<script setup lang="ts">
import {usePatientStore} from "@/stores/patient.store";
import {storeToRefs} from "pinia";
import {onMounted, ref} from "vue";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import ProfileFormFields from "@/interview/components/instance-modal/profile/ProfileFormFields.vue";
import usePatientProfile from "@/drug-interaction/composables/usePatientProfile";
import {CustomerProfile} from "@/drug-interaction/components/DrugInteractionPatientProfile.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";

const emits = defineEmits<{
    (e: 'next')
}>();

const props = defineProps<{
    customerId: number;
}>();

const patientStore = usePatientStore();
const {customer, loading: loadingCustomer} = storeToRefs(patientStore);

const {profile, saving, save} = usePatientProfile(customer, patientStore.patchCustomerProfile);

onMounted(() => {
    patientStore.load(props.customerId);
});

const data = ref({
    weight: profile.value.weight || undefined,
    height: profile.value.height || undefined,
    amenorrhoea: profile.value.amenorrhoea || undefined,
    breast_feeding: profile.value.breast_feeding || undefined,
    breast_feeding_date: profile.value.breast_feeding_date || undefined,
    hepatic: profile.value.hepatic || undefined,
    dfg: profile.value.dfg || undefined,
    pathologies: profile.value.pathologies || [],
    allergies: profile.value.allergies || [],
});

const finish = async () => {
    const profile: Omit<CustomerProfile, "id" | "is_dead"> = {
        weight: data.value.weight || null,
        height: data.value.height || null,
        amenorrhoea: data.value.amenorrhoea || null,
        breast_feeding: data.value.breast_feeding || null,
        breast_feeding_date: data.value.breast_feeding_date || null,
        hepatic: data.value.hepatic || null,
        dfg: data.value.dfg || null,
        pathologies: data.value.pathologies || [],
        allergies: data.value.allergies || [],
    };

    await saveProfile(profile);
};

const saveProfile = async (data: Omit<CustomerProfile, "id" | "is_dead">) => {
    return save(data)
        .then(() => {
            emits('next');
        });
};
</script>

<template>
  <div>
    <h3>Vérifiez et complétez le profil du patient</h3>
    <BaseFlexSpinner v-if="loadingCustomer" />
    <div v-else class="mt-2 bg-gray-100 p-4 rounded-lg flex flex-col gap-4">
      <ProfileFormFields v-model:data="data" />
      <div class="flex justify-end">
        <BaseButton primary :loading="saving" @click="finish">
          Terminer
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
